// extracted by mini-css-extract-plugin
export var forecastList = "styles-module__forecastList___L62kX";